import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';
import Hero from '@/pages/home/components/Hero';
import TodayUpdates from '@/pages/home/components/TodayUpdates';
import Categories from '@/pages/home/components/Categories';
import Discovery from '@/pages/home/components/Discovery';
import Testimonials from '@/pages/home/components/Testimonials';
import FaqPreview from '@/pages/home/components/FaqPreview';

export default function Home() {
  useSeo({
    title: '今日同人库 - 每日更新速递·最新汉化·连载追踪',
    description:
      '点开今日同人库，第一时间掌握今日同人库更新动态，今日同人库今日更新、最新汉化、新作连载都能快速找到，每日整理，追更不再错过。',
    keywords: '今日同人库,今日同人库更新,今日同人库今日更新,今日同人库汉化,今日同人库连载',
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: '今日同人库',
        url: 'https://gzsxkjjs.cn/',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://gzsxkjjs.cn/updates?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: '今日同人库',
        description: '每日整理同人作品更新动态、最新汉化与新作连载的资讯站点',
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Hero />
      <TodayUpdates />
      <Categories />
      <Discovery />
      <Testimonials />
      <FaqPreview />
      <section className="relative px-4 md:px-6 py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=soft%20illustrated%20background%20of%20scattered%20open%20books%2C%20paper%20lanterns%20and%20fireflies%20floating%20in%20a%20warm%20twilight%20sky%2C%20dusty%20rose%20cream%20and%20gold%20palette%2C%20calm%20and%20dreamy%20manga%20art&width=1600&height=500&seq=dj-cta-01&orientation=landscape"
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-foreground-950/70"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">追更从此不再错过</h2>
            <p className="mt-3 text-background-200 text-sm md:text-base">
              订阅更新速递，或从今日更新开始，第一时间发现你感兴趣的同人作品。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/updates"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap text-center"
            >
              浏览今日更新
            </Link>
            <a
              href="#subscribe"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
            >
              订阅更新提醒
            </a>
          </div>
        </div>
      </section>
    </>
  );
}